module.exports = __webpack_public_path__ + "img/cms_datasets_publish.35d6046e.jpg";